import {
	SET_TEAMS,
	SET_TEAM,
	CLEAR_TEAMS,
	CLEAR_TEAM,
	ADD_TEAM,
	UPDATE_TEAM,
	REMOVE_TEAM,
} from './actionTypes';

export const team = (state = {}, action) => {
	switch (action.type) {
		case SET_TEAM:
			return action.payload;
		case UPDATE_TEAM:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_TEAM:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_TEAMS:
			return action.payload;
		case ADD_TEAM:
			return [...state, action.payload];
		case UPDATE_TEAM:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_TEAM:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_TEAMS:
			return [];
		default:
			return state;
	}
};
